/** 
 * 获取设备ID，返回promise
 */
const getDeviceIdFromValiVersionP = () => {
    return new Promise(function (resolve) {
        var deviceid = ''
        try {
            window.webkit.messageHandlers.getDeviceId.postMessage({
                callBack: "getDeviceIdSuc"
            });
        } catch (e) {
            // 原来的获取活动ID的方法
            try {
                if (window.T.os.ios) {
                    deviceid = window.SecrectActivity.getDeviceId();
                } else if (window.T.os.android) {
                    deviceid = window.activity.getDeviceId();
                } else {
                    deviceid = "";
                }
                resolve(deviceid)
            } catch (e) {
                resolve('')
            }
        }
        window.getDeviceIdSuc = function (device) {
            resolve(device)
        };
    })
}
/** 
 * 获取用户登录信息,返回promise 
 */
const getUserInfoP = function () {
    return new Promise(function (resolve, reject) {
        try {
            window.webkit.messageHandlers.getUserInfo.postMessage({
                callBack: "getUserInfoSuc"
            });
        } catch (e) {
            try {
                resolve(JSON.parse(window.SecrectActivity.getUserInfo()));
            } catch (e) {
                reject(false);
            }
        }

        window.getUserInfoSuc = function (res) {
            if (res) {
                resolve(JSON.parse(res));
            }
        };
    });
}

/** 
 * 原生登陆 
 */
const nativeLoginP = () => {
    return new Promise((resolve) => {
        //弹出登录框
        window.location.href = "getLoginPhoneInfo:///";
        //手机客户端登录成功回调
        window.getLoginUserData = function (res) {
            if (res) {
                res = JSON.parse(res);
                resolve(res)
            }
        }
    })
}

/**
 * @description 获取端内版本号
 * @return Promise.resolve 此处均返回resolve，不需要抓异常
 */
const getInsideVersion = () => {
    return new Promise((resolve) => {
        try {
            window.webkit.messageHandlers.getVersionCode.postMessage({
                callBack: "getVersionCodeSuc"
            });
        } catch (e) {
            try {
                let version = parseInt(window.SecrectActivity.getVersionCode());

                if (window.T.os.android) {
                    version = version / 10;
                }
                resolve(version);
            } catch (e) {
                resolve(false);
            }
        }

        window.getVersionCodeSuc = function (targetVersion) {
            resolve(targetVersion);
        };
    });
}
/** 
 * 分享
 * @param title {String} - 分享标题
 * @param content {String} - 分享摘要
 * @param icon {String} - 分享图标
 * @param url {String} - 点击分享后跳转的链接
 * @param reporterUuid {String} - 记者Uuid，用于埋点 
 */
const share = ({
    title = '',
    content = '',
    icon = '',
    url = '',
    reporterUuid = ''
} = {}) => {
    let params = {
        title,
        content,
        icon,
        url,
        reporterUuid
    }
    let regObj = {
        '#': '%23',
        '$': '1',
        '%': '1',
        '[': '1',
        ']': '1'
    }
    let regStr = ''
    Object.keys(regObj).forEach((key) => {
        regStr += '\\' + key
    })

    let reg = new RegExp(`[${regStr}]`, 'ig')
    for (let key in params) {
        if (typeof params[key] === 'string') {
            params[key] = params[key].replace(reg, () => {
                return ''
            })
        }
    }
    if (window.T.os.ios) {
        params = JSON.stringify(params)
        window.location.href = `share:///${params}`
    } else {
        params.reporterUuid = params.reporterUuid.toString()
        params = JSON.stringify(params)
        window.location.href = `share:///${params}`
    } 
}

/**
 * 退出当前webview
 */
const closeWebView = () => {
    try {
        if (window.T.os.ios) {
            window.location.href = 'exit:///'
        } else {
            window.activity.finishActivity()
        }
    } catch (e) {
        window.console.warn(`当前app版本不支持该方法，请升级到4.9及以上`)
    }
}

/** 
 * 私信
 */
const privateLetter = (param = {}) => {
    return new Promise((resolve, reject) => {
        try {
            window.jsBridge.call('chatWithReporter', param, (ret) => {
                resolve(ret)
            })
        } catch (err) {
            window.console.warn(err)
            reject(err)
        }
    })
}

/** 
 * 获取记者订阅状态 
 * @resolve  0未订阅，1已订阅
 */
const getReporterSubStatus = (param = {}) => {
    return new Promise((resolve, reject) => {
        try {
            window.jsBridge.call('reporterSubStatus', param, (ret) => {
                resolve(ret)
            })
        } catch (err) {
            window.console.warn(err)
            reject(err)
        }
    })
}

/** 
 * 设置标题属性
 * @params option {Object} - 属性对象
 * @param option.titleColor [String = ''] - 标题颜色 ex: '#ffffff'
 * @param option.title [String = ''] - 标题内容
 * @param option.titleBarColor [String = ''] - 导航栏颜色
 * @param option.hiddenTitleBarLine [Number = 0] - 是否隐藏分割线，1隐藏分割线， 0不隐藏分割线
 * @param option.titleBarImgType [Number = 0] - 是否显示导航栏图标，1显示白色图标，0显示默认颜色图标
 * @param option.headerStyleType [Number = 0] - 是否显示状态 0显示，1不显示，2不显示导航栏且状态栏透明
 */
const setTitleBarAttribute = ({
    titleColor = '',
    title = '',
    titleBarColor = '',
    hiddenTitleBarLine = 0,
    titleBarImgType = 0,
    headerStyleType = 0
} = {}) => {
    return new Promise((resolve) => {
        let option = {}
        titleColor && (option.titleColor = titleColor)
        title && (option.title = title)
        titleBarColor && (option.titleBarColor = titleBarColor)
        hiddenTitleBarLine && (option.hiddenTitleBarLine = parseInt(hiddenTitleBarLine))
        titleBarImgType && (option.titleBarImgType = parseInt(titleBarImgType))
        headerStyleType && (option.headerStyleType = parseInt(headerStyleType))
        if (window.T.os.android) {
            option.callback = 'setTitleBarAttributeCallBack'
        }
        option = JSON.stringify(option)
        window.console.log('setTitleBarAttribute')
        window.console.log(option)
        try {
            if (window.T.os.ios) {
                option = JSON.parse(option)
                window.webkit.messageHandlers.setTitleBarAttribute.postMessage({
                    data: option,
                    callBack: 'setTitleBarAttributeCallBack'
                })
            } else {
                window.activity.setTitleBarAttribute(option)
            }
        } catch (e) {
            window.console.warn('当前没有该方法')
        }
        window.setTitleBarAttributeCallBack = () => {
            resolve(true)
        }
    })
}

/** 
 * 通知原生修改订阅状态
 * @param param {Object} - 参数对象
 * @param param.reporterUuid {String | Number} - 记者uuid
 * @param param.subStatus {Number} 1 - 已订阅，0 - 未订阅 
 */
const setNativeSubStatus = (param) => {
    return new Promise((resolve, reject) => {
        try {
            window.jsBridge.call('subscribeReporter', param, (ret) => {
                resolve(ret)
            })
        } catch (err) {
            window.console.warn(err)
            reject(err)
        }
    })
}

/** 
 * 获取埋点请求头
 */
const getHttpHeaders = (param = {}) => {
    return new Promise((resolve) => {
        try {
            window.jsBridge.call('getHttpHeaders', param, (ret) => {
                resolve(JSON.parse(ret))
            })
        } catch (err) {
            window.console.warn(err)
            resolve({})
        }
    })
}

export default {
    getDeviceIdFromValiVersionP,
    getUserInfoP,
    nativeLoginP,
    getInsideVersion,
    share,
    closeWebView,
    privateLetter,
    getReporterSubStatus,
    setTitleBarAttribute,
    setNativeSubStatus,
    getHttpHeaders
}